import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Social Media',
  subtitle: 'Marketing',
  tagline: 'Build Your Brand Online',
  icon: '',
  // icon: '📱',

  heroDesc: 'Grow your brand presence across Facebook, Instagram, LinkedIn, and more. We create data-driven social media campaigns that increase followers, boost engagement, and convert audiences into loyal customers.',
  mainStat: '3x',
  mainStatLabel: 'Average engagement increase for our clients',
  subStats: [
    { value: '93+', label: 'Accounts Managed' },
    { value: '500+', label: 'Happy Clients' },
  ],
  features: [
    { icon: '📋', title: 'Content Strategy', desc: 'Custom content calendars aligned with your brand voice and business goals.' },
    { icon: '🎨', title: 'Creative Content', desc: 'Eye-catching posts, reels, stories, and carousels designed to stop the scroll.' },
    { icon: '📊', title: 'Analytics & Reporting', desc: 'Monthly performance reports with actionable insights and growth metrics.' },
    { icon: '💬', title: 'Community Management', desc: 'Active engagement with your audience — responding to comments and messages.' },
    { icon: '📈', title: 'Growth Strategy', desc: 'Proven tactics to grow your follower base organically and sustainably.' },
    { icon: '🔁', title: 'Platform Management', desc: 'Complete management of Facebook, Instagram, LinkedIn, and Twitter profiles.' },
  ],
  benefits: [
    { title: 'Increase Brand Awareness', desc: 'Reach thousands of potential customers who have never heard of you before.' },
    { title: 'Build Customer Loyalty', desc: 'Consistent presence builds trust and keeps your audience engaged long-term.' },
    { title: 'Drive Website Traffic', desc: 'Convert social followers into website visitors and paying customers.' },
    { title: 'Generate Qualified Leads', desc: 'Targeted content attracts the right audience — people who actually want your product.' },
  ],
  process: [
    { title: 'Discovery & Audit', desc: 'We analyze your current social presence, competitors, and target audience to build a solid foundation.' },
    { title: 'Strategy Development', desc: 'A custom social media strategy is created with platform-specific goals and content pillars.' },
    { title: 'Content Creation', desc: 'Our creative team produces high-quality posts, graphics, reels, and stories tailored to your brand.' },
    { title: 'Publishing & Scheduling', desc: 'Content is published at optimal times for maximum reach and engagement.' },
    { title: 'Monitor & Optimize', desc: 'We track performance daily and continuously optimize for better results.' },
  ],
  whyChoose: [
    { icon: '🏆', title: '93+ Accounts Managed', desc: 'We\'ve successfully grown dozens of brands across all major platforms.' },
    { icon: '📊', title: 'Data-Driven', desc: 'Every decision is backed by real data, not guesswork.' },
    { icon: '🎨', title: 'Creative Excellence', desc: 'Stunning content that stands out in crowded social feeds.' },
    { icon: '💰', title: 'Affordable Packages', desc: 'Flexible plans designed for every business size and budget.' },
  ],
  reviews: [
    { name: 'Ravi Sharma', role: 'Restaurant Owner', text: 'Our Instagram following grew from 200 to 8,000 in 6 months. DMS Technologies is incredible!' },
    { name: 'Neha Patel', role: 'Fashion Brand', text: 'The content they create is absolutely stunning. Our engagement rate went through the roof.' },
    { name: 'Amit Kumar', role: 'Fitness Studio', text: 'Professional, responsive, and result-oriented. Highly recommend DMS for social media!' },
  ],
  faq: [
    { q: 'How quickly will I see results?', a: 'Most clients see noticeable improvements in engagement and reach within 30–60 days. Significant follower growth typically happens within 3–6 months.' },
    { q: 'Which platforms do you manage?', a: 'We manage Facebook, Instagram, LinkedIn, Twitter/X, YouTube, and WhatsApp Business profiles.' },
    { q: 'Do you create the content as well?', a: 'Yes! Our creative team handles everything — graphics, copywriting, reels, stories, and carousels.' },
    { q: 'How often will you post?', a: 'Depending on your plan, we post 3–7 times per week per platform, always at optimal engagement times.' },
  ],
};

export default function SocialMediaMarketing() {
  return <ServiceTemplate data={data} />;
}
